/* eslint-disable no-unused-vars */
import React,{ useEffect,useState } from 'react';
import { Breadcrumb, Row, Col, Card, Table,BackTop, DatePicker, Form, Select, Space, Radio, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { fetchAdminApi } from "../../../services/api";
import constants from "../../../constants/constants";
import { useHistory } from "react-router";
import moment from 'moment';
import { Chart } from "react-google-charts";
import { registrationFilter } from '../../../globalFunctions/GlobalFunctions';
const { Option } = Select;
const TestTakenDetails =(props)=> {
	const history = useHistory();
	const [allTestData, setAllTestData] = useState({});
	const [endDate, setEndDate] = useState("");
	const [startDate, setStartDate] = useState("");
	const [testType,setTestType]=useState(props.location.state.testType);
	const [fullLengthGraphData, setFullLengthGraphData] = useState([]);
	const [fullLengthData, setFullLengthData] = useState([]);
	const [categoryData, setCategoryData] = useState([]);
	const [categoryGraphData, setCategoryGraphData] = useState([]);
	const [topicData, setTopicData] = useState([]);
	const [topicGraphData, setTopicGraphData] = useState([]);
	const [duration,setDuration]=useState(props&&props.location&&props.location.state&&props.location.state.duration?props&&props.location&&props.location.state&&props.location.state.duration:"1");
	const [form] = Form.useForm();
	const [showGraph,setShowGraph]=useState(true);
	useEffect(() => {
		if(props&&props.location&&props.location.state&&props.location.state.type&&props.location.state.type==="dashboard"){
			setDateFilters(constants.startDateOfTheYear,constants.endDateOfTheYear);
			fetchTableData(constants.startDateOfTheYear,constants.endDateOfTheYear);
		}else{
			if(props&&props.location&&props.location.state){
				setStartDate(moment(props&&props.location&&props.location.state&&props.location.state.startDate).format("MM/DD/YYYY"));
				setEndDate(moment(props&&props.location&&props.location.state&&props.location.state.endDate).format("MM/DD/YYYY"));
				form.setFieldsValue({
					from:moment(props&&props.location&&props.location.state&&props.location.state.startDate),
					to:moment(props&&props.location&&props.location.state&&props.location.state.endDate)
				});
				fetchTableData(
					props&&props.location&&props.location.state&&props.location.state.startDate,
					props&&props.location&&props.location.state&&props.location.state.endDate
				);
			}else{
				fetchTableData();
			}
		}
	}, []);
	const setDateFilters=(startDate,endDate)=>{
		setStartDate(moment(startDate).format("MM/DD/YYYY"));
		setEndDate(moment(endDate).format("MM/DD/YYYY"));
		form.setFieldsValue({
			from:moment(startDate),
			to:moment(endDate)
		});
		setDuration("0");
	};
	const noDataAvailableText=()=>{
		return(
			<>							
				<div className="nograph-div">
					<span>No Data Available.</span>
				</div>
			</>
		);
	};
	const displayGraph=(dataSet)=>{
		if(dataSet.length>0)
		{
			return true;
		}else{
			return false;
		}
	};
	const fetchTableData = (startDateValue,endDateValue) =>{
		var startDate=null;
		var endDate=null;
		if(startDateValue&&endDateValue){
			startDate=moment(startDateValue).format("YYYY-MM-DD");
			endDate=moment(endDateValue).format("YYYY-MM-DD");
		}else{
			var date = new Date(), y = date.getFullYear(), m = date.getMonth();
			var firstDay = new Date(y, m, 1);
			var lastDay = new Date(y, m + 1, 0);
			startDate=moment(firstDay).format("YYYY-MM-DD");
			endDate=moment(lastDay).format("YYYY-MM-DD");
			setStartDate(moment(startDate).format("MM/DD/YYYY"));
			setEndDate(moment(endDate).format("MM/DD/YYYY"));
			form.setFieldsValue({
				from:moment(startDate),
				to:moment(endDate)
			});
		}
		fetchAdminApi(`/total-tests-taken-data?start_date=${startDate}&end_date=${endDate}`, "get").then(
			(res) => {
				if (res && res.data) {
					console.log("response",res.data);
					console.log("props",props);
					if(props&&props.location&&props.location.state&&props.location.state.type){
						setAllTestData(res.data);
						setCategoryData(res.data?.Category.filter((item)=>item.test_type===props.location.state.type));
						setTopicData(res.data?.Topic.filter((item)=>item.test_type===props.location.state.type));
						console.log("tempFulllengthData 1",res.data?.Full_length.filter((item)=>item.test_type===props.location.state.type));
						setFullLengthData(res.data?.Full_length.filter((item)=>item.test_type===props.location.state.type));
					}else{
						setAllTestData(res.data);
						setCategoryData(res.data?.Category);
						setTopicData(res.data?.Topic);
						setFullLengthData(res.data?.Full_length);
					}
					if(res.data.Full_length){
						let tempFulllengthData=res.data.Full_length.filter((item)=>item.test_type===props.location.state.type);
						// setFullLengthData(res.data?.Full_length);
						console.log("tempFulllengthData 2",tempFulllengthData);
						let fullLengthChartData = [
							["No. of Tests", "Pass", "Did not Pass"],
						];
						for (let index = 0; index < tempFulllengthData.length; index++) {
							let fullLength=[];
							fullLength.push("Test "+tempFulllengthData[index].test_type,Number(tempFulllengthData[index].pass),Number(tempFulllengthData[index].fail));
							fullLengthChartData.push(fullLength);
						}
						setFullLengthGraphData(fullLengthChartData);
					}
					if(res.data.Category){
						// setCategoryData(res.data.Category);
						let temCategoryData=res.data.Category.filter((item)=>item.test_type===props.location.state.type);
						let categoryChartData = [
							["No. of Tests", "Pass", "Did not Pass"],
						];
						for (let index = 0; index < temCategoryData.length; index++) {
							let category=[];
							category.push(temCategoryData[index].test_type+" #"+temCategoryData[index].attempt,Number(temCategoryData[index].pass),Number(temCategoryData[index].fail));
							categoryChartData.push(category);
						}
						setCategoryGraphData(categoryChartData);
					}
					if(res.data.Topic){
						// setTopicData(res.data.Topic.);
						let tempTopicdata=res.data.Topic.filter((item)=>item.test_type===props.location.state.type);
						let topicChartData = [
							["No. of Tests", "Pass", "Did not Pass"],
						];
						for (let index = 0; index < tempTopicdata.length; index++) {
							let topic=[];
							topic.push(tempTopicdata[index].test_type,Number(tempTopicdata[index].pass),Number(tempTopicdata[index].fail));
							topicChartData.push(topic);
						}
						setTopicGraphData(topicChartData);
					}
				}
			}
		);
	};
	const optionsforFullLengthAndCategory = {
		title: "Test Scores",
		height: 400,
		isStacked: true,
		vAxis: {
			title: "No. of Tests",
			titleTextStyle: {
				fontName: "sans-serif",
				fontSize: 15,
				bold: true,
				italic: false
			}
		},
		hAxis: { 
			title: "Tests" ,
			titleTextStyle: {
				fontName: "sans-serif",
				fontSize: 15,
				bold: true,
				italic: false
			}
		},
		seriesType: "bars",
	};
	const optionsforTopic = {
		title: "Test Scores",
		height: 400,
		isStacked: true,
		vAxis: {
			title: "No. of Tests",
			titleTextStyle: {
				fontName: "sans-serif",
				fontSize: 15,
				bold: true,
				italic: false
			}
		},
		hAxis: { textPosition: 'none' },
		seriesType: "bars",
	};
	const column3 = [
		{
			title: "Test type",
			key: "testtype",
			dataIndex: "test_type",
			render: (_text, record) => {
				return<span className="p-relative">{record.test_type?record.test_type:""}</span>;
			},
			align: 'left',
			width:100
		},
		{
			title: "Attempt",
			key: "attempt",
			className: 'td-right',
			render: (_text, record) => {
				return <span className="p-relative">{record.attempt}</span>;
			},
			align: 'center',
			width:100
		},
		{
			title: "Pass",
			key: "Pass",
			dataIndex: "pass",
			className: 'td-right',
			render: (_text, record) => {
				return <span className="p-relative">{record.pass}</span>;
			},
			align: 'center',
			width:100
		},
		{
			title: "Did not Pass",
			key: "Did not Pass",
			dataIndex: "fail",
			className: 'td-right',
			render: (_text, record) => {
				return <span className="p-relative">{record.fail}</span>;
			},
			align: 'center',
			width:100
		},
		{
			title: "Pass %",
			key: "pass percentage",
			className: 'td-right',
			render: (_text, record) => {
				let pass = record.pass?Number(record.pass):0;
				let total = record.total?Number(record.total):0;
				let percentage =(pass/total)*100;
				return <span className="p-relative">{percentage.toFixed()}</span>;
			},
			align: 'center',
			width:100
		},
		{
			title: "Total",
			key: "total",
			dataIndex: "total",
			className: 'td-right',
			render: (_text, record) => {
				return <span className="p-relative">{record.total}</span>;
			},
			align: 'center',
			width:100
		},
	];
	const columnCategory = [
		{
			title: "Test type",
			key: "testtype",
			dataIndex: "test_type",
			render: (_text, record) => {
				return<span className="p-relative">{record.test_type?record.test_type+" #"+record.attempt:""}</span>;
			},
			align: 'left',
			width:100
		},
		{
			title: "Pass",
			key: "Pass",
			dataIndex: "pass",
			className: 'td-right',
			render: (_text, record) => {
				return <span className="p-relative">{record.pass}</span>;
			},
			align: 'center',
			width:100
		},
		{
			title: "Did not Pass",
			key: "Did not Pass",
			dataIndex: "fail",
			className: 'td-right',
			render: (_text, record) => {
				return <span className="p-relative">{record.fail}</span>;
			},
			align: 'center',
			width:100
		},
		{
			title: "Pass %",
			key: "pass percentage",
			className: 'td-right',
			render: (_text, record) => {
				let pass = record.pass?Number(record.pass):0;
				let total = record.total?Number(record.total):0;
				let percentage =(pass/total)*100;
				return <span className="p-relative">{percentage.toFixed()}</span>;
			},
			align: 'center',
			width:100
		},
		{
			title: "Total",
			key: "total",
			dataIndex: "total",
			className: 'td-right',
			render: (_text, record) => {
				return <span className="p-relative">{record.total}</span>;
			},
			align: 'center',
			width:100
		},
	];
	const columnFullLength = [
		{
			title: "Test type",
			key: "testtype",
			dataIndex: "test_type",
			render: (_text, record) => {
				return<span className="p-relative">{record.test_type?record.test_type:""}</span>;
			},
			align: 'left',
			width:100
		},
		{
			title: "Pass",
			key: "Pass",
			dataIndex: "pass",
			className: 'td-right',
			render: (_text, record) => {
				return <span className="p-relative">{record.pass}</span>;
			},
			align: 'center',
			width:100
		},
		{
			title: "Did not Pass",
			key: "Did not Pass",
			dataIndex: "fail",
			className: 'td-right',
			render: (_text, record) => {
				return <span className="p-relative">{record.fail}</span>;
			},
			align: 'center',
			width:100
		},
		{
			title: "Pass %",
			key: "pass percentage",
			className: 'td-right',
			render: (_text, record) => {
				let pass = record.pass?Number(record.pass):0;
				let total = record.total?Number(record.total):0;
				let percentage =(pass/total)*100;
				return <span className="p-relative">{percentage.toFixed()}</span>;
			},
			align: 'center',
			width:100
		},
		{
			title: "Total",
			key: "total",
			dataIndex: "total",
			className: 'td-right',
			render: (_text, record) => {
				return <span className="p-relative">{record.total}</span>;
			},
			align: 'center',
			width:100
		},
	];
	const handleStartDate = (_date, dateString) => {
		setStartDate(dateString);
		fetchTableData(dateString,endDate);
	};
	const handleEndDate = (_date, dateString) => {
		setEndDate(dateString);
		fetchTableData(startDate,dateString);
	};
	const disabledFutureDate = (current) => {
		return current && current > moment().endOf('day');
	};
	const disabledPastDate = (current) => {
		const startdate = moment(startDate);
		const today = moment().endOf("day");
		return !(startdate.isSameOrBefore(current) && today.isAfter(current));
	};
	const onChangeDateFilter = (e) => {
		setDuration(e);
		registrationFilter(e,setStartDateEndDate);
	};
	const onChangeTestType = (e) => {
		setTestType(e.target.value);
	};
	const setStartDateEndDate = (startDate,endDate) => {
		setStartDate(startDate);
		setEndDate(endDate);
		form.setFieldsValue({
			from:moment(startDate),
			to:moment(endDate)
		});
		fetchTableData(startDate,endDate);
	};
	const totalColumn = (type_total,pass,fail,height) =>{
		return (<Table.Summary.Row style = {{ 
			fontWeight:500 ,
			height:height 
		}}>
			<Table.Summary.Cell align = "left" index={0}><span>Total</span></Table.Summary.Cell>
			<Table.Summary.Cell index={1} className='td-right'><span className="p-relative">{type_total}</span></Table.Summary.Cell>
			<Table.Summary.Cell index={2} className = "td-right"><span className="p-relative">{pass}</span></Table.Summary.Cell>
			<Table.Summary.Cell index={3} className = "td-right"><span className="p-relative">{fail}</span></Table.Summary.Cell>
		</Table.Summary.Row>);
	};
	return (
		<>
			<div className="div">
				<BackTop/>
				<div className="p-3">
					<Breadcrumb>
						<Breadcrumb.Item ><a onClick={() => {
							history.push({ pathname: "/admin-dashboard" });
						}}>Home</a></Breadcrumb.Item>
						<Breadcrumb.Item ><a onClick = {() => {
							history.push({ pathname :"/analysis-menu" });
						}}>Analysis</a></Breadcrumb.Item>
						<Breadcrumb.Item><a onClick = {() =>{history.push("/test-scores");}}>{constants.TestScores}</a></Breadcrumb.Item>
						<Breadcrumb.Item>Test Score Details</Breadcrumb.Item>
					</Breadcrumb>
				</div>
				<div>
					<Row gutter={[24, 24]}>
						<Col xs={24} sm={24} md={24} lg={24}>
							<Card bordered size="small" title={<span className="text-uppercase">{constants.TestScores}</span>}
								extra={
									<Form layout="horizontal" form = {form}>
										<Space>
											<Form.Item className="label-default mb-0">
												{/* <Radio.Group value={testType} onChange={onChangeTestType} placeholder="Select test type" >
													<Radio value={1}>Full Length</Radio>
													<Radio value={2}>Category</Radio>
													<Radio value={3}>Topic</Radio>
												</Radio.Group> */}
											</Form.Item>
											<Form.Item className="label-default mb-0" label="From:" name = "from">
												<DatePicker defaultValue={startDate} onChange={ handleStartDate} disabledDate={disabledFutureDate} format="MM/DD/YYYY" inputReadOnly={true}/>
											</Form.Item>
											<Form.Item className="label-default mb-0" label="To:" name = "to">
												<DatePicker defaultValue={endDate} onChange={handleEndDate} disabledDate={disabledPastDate} format="MM/DD/YYYY" inputReadOnly={true}/>
											</Form.Item>
											<Form.Item className="label-default mb-0">
												<Select value={duration} style={{ width: 200 }} onChange={onChangeDateFilter} placeholder="Select period" >
													<Option value="0">This Year</Option>
													<Option value="7">Last Year</Option>
													<Option value="1">This Month</Option>
													<Option value="2">Last Month</Option>
													<Option value="3">Last 3 Months</Option>
													<Option value="4">This Month (Last Year)</Option>
													<Option value="5">Last 3 Months (Last Year)</Option>
													<Option value="6">Previous Years</Option>
												</Select>
											</Form.Item>
										</Space>
									</Form>
								}
							>
								<Row>
									<Col xs={24} sm={24} md={8} lg={8}>
										<span style = {{ 
											fontWeight:500,
											fontSize:"medium"
										}}>{startDate&&endDate&&`Search Criteria: From: ${moment(startDate).format("MM/DD/YYYY")} To: ${moment(endDate).format("MM/DD/YYYY")}`}</span>
										<Table className="gap-table"
											bordered
											columns={testType&&testType===1?columnFullLength: testType&&testType===2?columnCategory: column3}
											// dataSource={testType&&testType===1?fullLengthData&&fullLengthData.length>0?fullLengthData:[]:testType&&testType===2?
											// 	categoryData&&categoryData.length>0?categoryData:[]:testType&&testType===3?topicData&&topicData.length>0?topicData:[]:[]}
											dataSource={testType&&testType===2?categoryData:testType&&testType===1?fullLengthData:topicData}
											pagination={false}
											locale={{ emptyText: 'No Records Found' }}
											// summary={() => (
											// 	<Table.Summary fixed>
											// 		{testType&&testType===1?
											// 			totalColumn(allTestData&&allTestData?.fulllength_total,allTestData&&allTestData?.fulllength_pass,allTestData&&allTestData?.fulllength_fail):
											// 			testType&&testType===2?totalColumn(allTestData&&allTestData?.category_total,allTestData&&allTestData?.category_pass,allTestData&&allTestData?.category_fail):
											// 				testType&&testType===3?totalColumn(allTestData&&allTestData?.topic_total,allTestData&&allTestData?.topic_pass,allTestData&&allTestData?.topic_fail):
											// 					""}
											// 	</Table.Summary>
											// )}
										/>
									</Col>
									<Col xs={24} sm={24} md={16} lg={16}>
										{displayGraph(testType&&testType===2?categoryData:testType&&testType===1?fullLengthData:topicData)?
											<Chart
												chartType="ComboChart"
												width="100%"
												data={
													testType&&testType===2?
														categoryGraphData.length>0?categoryGraphData:[]:
														testType&&testType===1?
															fullLengthGraphData.length>0?fullLengthGraphData:[]:
															topicGraphData.length>0?topicGraphData:[]
												}
												options={testType&&testType===1||testType&&testType===2?optionsforFullLengthAndCategory:testType&&testType===3?optionsforTopic:{}}
											/>
											:
											noDataAvailableText()
										}
									</Col>
								</Row>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		</>
	);
};
export default TestTakenDetails;
